export const Updates = [
  {
    version: '3.0.5',
    time: '2024-05-27T00:00:00.000Z',
    title: 'ZKEX Update — 05/27/2024',
    content: [
      'Modify the time period in charts.',
      'Add logo to the chart background to enhance brand recognition.',
      'Add token information (Spot: minimum order quantity and 24-hour trading volume, Perp: trading rules, funding rates, and insurance funds).',
      'Adjust certain visual effects.',
    ],
  },
  {
    version: '3.0.4',
    time: '2024-05-20T00:00:00.000Z',
    title: 'ZKEX Update — 05/20/2024',
    content: [
      'Optimize the visual effects for deposit, withdrawal, wallet connection, account activation, and convert.',
      'Adjust the beginner‘s tutorial, modify the rounded corner buttons and the position of the sequence numbers.',
    ],
  },
  {
    version: '3.0.3',
    time: '2024-05-14T00:00:00.000Z',
    title: 'ZKEX Update — 05/14/2024',
    content: [
      'Add a "Max" button to the quantity input box in the Create Order area for both spot and perpetual trading.',
      'Introduce a slider for adjusting order quantities in the Create Order area for perpetual trading.',
      `Add detailed steps for activating an account to the beginner's tutorial.`,
      `Optimize the UI of navigation, wallet panel, and the Create Order areas for both spot and perpetual trading.`,
      `Add mobile compatibility to the Rewards page.`,
    ],
  },
  {
    version: '3.0.2',
    time: '2024-04-26T00:00:00.000Z',
    title: 'ZKEX Update — 04/26/2024',
    content: [
      'Integrate Assets, Positions, Open Orders, History, and integrate the asset portfolio management system.',
      'Added monthly and quarterly view options to asset data graphs.',
      'History adds a variety of filtering conditions, including query functions such as time, currency, buying and selling direction, order status, ID number, etc.',
      'User assets on the spot trading interface and asset interface are sorted from high to low according to currency value.',
    ],
  },
  {
    version: '3.0.1',
    time: '2024-04-16T00:00:00.000Z',
    title: 'ZKEX Update — 04/16/2024',
    content: [
      'Added perpetual trading service, providing more diversified trading options and strategies.',
      'Brand new website design, showcasing new product features for a refreshed visual experience.',
      'Redesigned UI for a smoother user experience.',
      'Expanded support for blockchain networks, integrating more blockchain ecosystems.',
      'Added quick-access wallet panel for improved operational efficiency.',
      'Introduced beginner tutorials to assist new users in quickly understanding website functionality.',
      'Added Convert popup on the spot trading page to enhance trading efficiency.',
      'Added market quote indicator preference settings on the spot trading page.',
      'Introduced Post-only feature for spot trading orders to offer more order types.',
      'Added Status feature to display personal user data on V2.',
      'Optimized navigation structure to make it easier for users to find desired features.',
      'Enhanced UI design and user experience on the spot trading page.',
      'Improved UI design and user experience for Convert.',
      'ZKEX V3 boasts speeds of up to 1000 TPS and scalability.',
      'More trading pairs, lightning-fast order matching, low latency, and low spreads.',
    ],
  },
  {
    version: '2.2.0',
    time: '2023-08-30T00:00:00.000Z',
    title: 'ZKEX Update [2.0 mainnet] — 08/30/2023',
    content: [
      'Added a quick withdraw icon in the withdrawal history.',
      'Added Show self-transaction status in Trade record and link to https://docs.zkex.com/overview/trading#self-trade',
      'Added Flashcash pairs in the list of pairs, and click on them to jump to the corresponding Flashcash interface (no pairs are shown on the main website yet, so the function is not visible for now).',
      'Fixed the recommended GasLimit for recharging Arbitrum and zkSync Era has been increased to 3,500,000.',
      'Optimization Streamline the process of getting the status of the withdrawal record, when there is an acceptance record, it will be considered that the withdrawal has reached the account and display Success status.',
      'Optimize the text of the Commission Fee in the withdrawal interface to Withdrawal Fee.',
    ],
  },
  {
    version: '2.1.0',
    time: '2023-08-10T00:00:00.000Z',
    title: 'ZKEX Update — 08/10/2023',
    content: [
      'Added mainnet support for two chains: Optimism (10) and Base (8453). Both chains have a block confirmation count of 30, with an estimated deposit waiting time of 1 minute.',
      'Fixed the timestamp format to microseconds in the historical records interface.',
      'Fixed the display issue of pending records for non-18 precision tokens in deposits.',
    ],
  },
  {
    version: '2.0.9',
    time: '2023-08-04T00:00:00.000Z',
    title: 'ZKEX Update — 08/04/2023',
    content: [
      'Migrating zkex docs to GitBook: https://docs.zkex.com/overview/what-is-zkex',
      'Clear quantity input field and slider after placing an order.',
      'Flash exchange page checks account status; if the account is not activated, it needs to be activated before proceeding with flash exchange transactions.',
      'In scenarios where MetaMask is not installed, display "Install MetaMask" with a link redirecting to metamask.io.',
      'For deposits, the estimated time of arrival will vary based on each blockchain. Chains without specified configurations will default to displaying 3-5 minutes.',
      'Upon successful deposit, a persistent notification window will appear at the bottom of the main interface until the user manually clicks to dismiss it.',
      'Add a linked icon next to "Trade fees" that redirects to the documentation for viewing the trading fee rules.',
      'Add a thumbnail for sharing purposes.',
      'The transfer operation should display "They will receive" instead of "You will receive."',
      'Introduce a new aggregated page for viewing historical records.',
    ],
  },
  {
    version: '2.0.8',
    time: '2023-07-31T00:00:00.000Z',
    title: 'ZKEX Update — 07/31/2023',
    content: [
      'Portfolio style fixes.',
      'Corrected incomplete timeline nodes in the portfolio chart. Previously, for new users recharging on the first day, only one node was displayed on the chart.',
      'Suggested $5000 USD is displayed beneath the recharge amount input field.',
      'Enhanced messaging for the recharge waiting popup.',
    ],
  },
  {
    version: '2.0.7',
    time: '2023-07-15T00:00:00.000Z',
    title: 'ZKEX Update — 07/15/2023',
    content: [
      'Dynamically adjust order placement fees, refer to https://docs.zkex.com/overview/fees#trading-fees for specific rules.',
      'Introduce partially filled status for new orders.',
      'Implement minor adjustments.',
    ],
  },
  {
    version: '2.0.6',
    time: '2023-04-10T00:00:00.000Z',
    title: 'ZKEX Update — 04/10/2023',
    content: [
      'Optimize deposit processing speed.',
      'Enhance fee calculation rules for transfers and withdrawals.',
      'Improve withdrawal button experience for faster interaction response.',
      'Offer the total remaining supply query for each token on every chain.',
    ],
  },
  {
    version: '2.0.5',
    time: '2023-01-11T00:00:00.000Z',
    title: 'ZKEX Update — 01/11/2023',
    content: [
      'Added self-settlement for ZKEX',
      'Added JOE and QUICK trading pairs',
      'Added Binance Chart',
      'New CSV export function for order history and trade history',
      'Fixed the problem of delayed status synchronization after user activation',
      'Fixed the problem of the infinite amount of user depositing and withdrawing',
      'Fixed the problem of not being able to load the historical K-line chart',
      'Fixed the problem of slow and unstable faucet claiming speed',
      'Fixed the problem of automatic cancellation of orders',
      'Fixed the problem of the faucet could only claim stable coin on L1',
    ],
  },
  {
    version: '1.1.3',
    time: '2022-11-10T00:00:00.000Z',
    title: 'ZKEX Update — 11/10/2022',
    content: [
      'Added auto restart for layer 2 server',
      'Set alpha test for web mobile develop version',
      'Fixed tradingview cache bug',
      'Fixed depositing bug in AVAX',
      'Fixed market making bot speed',
      'Increased deposit limit',
      'Set devnet for new layer 2 server',
      'Added address book feature for devnet',
      'Other bugs fixed',
    ],
  },
  {
    version: '1.1.2',
    time: '2022-10-21T00:00:00.000Z',
    title: 'ZKEX Update — 10/21/2022',
    content: [
      'Fixed the delay in the "Open Order"',
      'Fixed Layer 2 faucet bug which prevents scripts to claim faucet',
      'Increase the speed of claim faucet',
      'Added investment portfolio',
      'Fixed the "No data" bug in the portfolio',
      'Order placing notification logic changed for a better user experience',
      'Added a confirmation pop-up for “cancel all’ to prevent misclick',
      'Fixed the withdraw ccommissionfee bug',
      'Other bugs fixed',
    ],
  },
  {
    version: '1.1.1',
    time: '2022-10-10T00:00:00.000Z',
    title: 'ZKEX Update — 10/10/2022',
    content: [
      'Improved the display speed of "open order"',
      'Faucet bug fixed',
      'Supported mobile users for now, we will make it responsive later',
      'Improved the max number of matching orders during a fixed time in layer 2',
      'Faster order matching speed',
      'Depositing bug fixed',
      'Limit order pricing bug fixed',
      'Trade fee calculation bug fixed',
      'Support balance hiding',
      'Other bugs fixed',
    ],
  },
  {
    version: '1.1.0',
    time: '2022-09-22T00:00:00.000Z',
    title: 'ZKEX Update — 09/22/2022',
    content: [
      'We added a slider to the order panel',
      'The "trade fee" is more specific',
      'Add more notifications to help new users',
      'Other bugs fixed',
    ],
  },
  {
    version: '1.0.9',
    time: '2022-09-16T00:00:00.000Z',
    title: 'ZKEX Update — 09/16/2022',
    content: [
      'Added info explantion for ordering withour signature',
      'Increase transaction processing speed',
      'Faster deposit/withdraw speed',
      'Enable fast withdraw option',
      'Added bug report session, removed rating session',
      'Longer time for toast/notification',
      'New website launch',
      'Other bug fixes',
    ],
  },
  {
    version: '1.0.8',
    time: '2022-09-02T00:00:00.000Z',
    title: 'ZKEX Update — 09/02/2022',
    content: [
      'Updated UI to version V1.2',
      'Added commission fee calculation',
      'ZKEX new website design V1.1',
      'Added Wallet Connect',
      'Cryptocurrency depositing bug fix',
      'Tradingview panel is smoother now',
      'User could withdraw within unsupport network condition',
      'Preparation for testnet',
      'Other bug fixes',
    ],
  },
  {
    version: '1.0.7',
    time: '2022-08-26T00:00:00.000Z',
    title: 'ZKEX Update — 08/26/2022',
    content: [
      'Updated UI to version V1.2',
      'ZKEX bew website design, yes we will a new website!',
      'New website animation motions & plugins',
      'New page for Balance history',
      'Adding connection feature to check current network status',
      'New DEX rating system',
      'Added coinbase wallet',
      'Preparation for testnet',
      'Other bug fixes',
    ],
  },
  {
    version: '1.0.6',
    time: '2022-08-19T00:00:00.000Z',
    title: 'ZKEX Update — 08/19/2022',
    content: [
      'Updated UI to version V1.1',
      'Added wrapped tokens to faucet',
      'Fixed order book flickering bug',
      'Fixed order amount percentage bug',
      'Fixed tradingview connection bug',
      'Fixed tradingview axis & dark mode bug',
      'Fixed trade history matching type bug',
      'Set up withdrawl/Deposit chart',
      'Preparation for testnet',
      'Other bug fixes',
    ],
  },
  {
    version: '1.0.5',
    time: '2022-08-12T00:00:00.000Z',
    title: 'ZKEX Update — 08/12/2022',
    content: [
      'Updated UI to version V1.0',
      'Added more tokens: wETH, wBTC, wAVAX and wMATIC',
      'Added BUSD as a supported stablecoin',
      'Finalized market maker’s API',
      'Improved r account opening experience',
      'Set up Wallet address window',
      'Fixed order history panel bug',
      'Fixed order matching limit bug',
      'Fixed faucet depositing bug',
      'Adding more features on the Tradingview chart',
      'Preparation for testnet',
      'Other bug fixes',
    ],
  },
  {
    version: '1.0.4',
    time: '2022-08-05T00:00:00.000Z',
    title: 'ZKEX Update — 08/05/2022',
    content: [
      'Updated UI to version V0.73',
      'Tradingview dark mode',
      'New faucet window',
      'Added Layer 1 faucet',
      'New connect wallet expierence',
      'Setting up Market Making bot',
      'Better depositing experience',
      'Search feature updated',
      'Better market order experience',
      'Closing to testnet',
      'Other bug fixes',
    ],
  },
  {
    version: '1.0.3',
    time: '2022-07-29T00:00:00.000Z',
    title: 'ZKEX Update — 07/29/2022',
    content: [
      'Updated UI to version V0.5',
      'New Light and Dark mode',
      'New Order history panel',
      'Added display filled amount in open order panel',
      'Added trading history',
      'Added BUSD as stablecoin withdrawal option',
      'Added more trading pairs',
      'New Balance history panel',
      'Setup partnership with Market Maker',
      'Optimized UI & UX code',
      'New style notification modals',
      'Serial market order bug fixed',
      'Other bug fixes',
    ],
  },
  {
    version: '1.0.2',
    time: '2022-07-22T00:00:00.000Z',
    title: 'ZKEX Update — 07/22/2022',
    content: [
      'Layer1 and Layer2 faucet depositing',
      'UI verison V0.4, applying brand color to all windows',
      'Wallet switch experience',
      'Market Maker API finished',
      'Docs for Market Maker finished',
      'Adding market order 2nd version',
      'Adding three different modes for orderbook panel',
      'Bug fix',
    ],
  },
  {
    version: '1.0.1',
    time: '2022-07-15T00:00:00.000Z',
    title: 'ZKEX Update — 07/15/2022',
    content: [
      'Multi-chain depositing and withdrawl features, which is an innovation features and requires more feedbacks',
      'UI verison V0.34',
      'Dark mode UI designing finished',
      'Connecting wallet experience, wrong network part',
      'Adding market order 1st version',
      'Adding wallet connect',
      'New notification UI',
      'Bug fix',
      'Better signature experience',
    ],
  },
]
